// extracted by mini-css-extract-plugin
module.exports = {"baseStyle":"Button_baseStyle__NGJTM","secondary":"Button_secondary__2SgR_"};